import { api, unwrap } from "./httpClient";
import type {
  AdminListUsersQuery,
  PaginationMeta,
  Role,
  User,
} from "../types/api";

export interface AdminCreateUserPayload {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  role: Role["name"];
  status: "active" | "suspended";
  managerId?: number | null;
}

export interface AdminUpdateUserPayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  /** Laisser vide pour ne pas modifier le mot de passe. */
  password?: string;
  role?: Role["name"];
  status?: "active" | "suspended";
  notifyEmail?: boolean;
  notifySms?: boolean;
  managerId?: number | null;
  /** Nombre max de robots que le client peut configurer (défini par le manager). */
  maxTradingBots?: number | null;
  /** Autoriser le client à voir l'onglet Robot et à activer ses robots (défini par le manager). */
  tradingBotAllowed?: boolean;
  /** Statut de suivi CRM du client. */
  followupStatus?:
    | "new"
    | "no_response"
    | "voicemail"
    | "not_interested"
    | "deposit_done"
    | "potential_low"
    | null;
}

export const listUsers = async (params?: AdminListUsersQuery) => {
  const response = await api<User[]>({
    method: "GET",
    url: "/admin/users",
    params,
  });
  return {
    users: response.data.data ?? [],
    meta: (response.data.meta ?? null) as PaginationMeta | null,
  };
};

export const createUser = (payload: AdminCreateUserPayload) =>
  unwrap<User>(api({ method: "POST", url: "/admin/users", data: payload }));

export const updateUser = (userId: number, payload: AdminUpdateUserPayload) =>
  unwrap<User>(
    api({ method: "PATCH", url: `/admin/users/${userId}`, data: payload })
  );

export const getUserPositions = (userId: number) =>
  unwrap<import("../types/api").TradingPosition[]>(
    api({
      method: "GET",
      url: `/admin/users/${userId}/positions`,
    })
  );

export interface SimulationClientSummary {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: Role["name"];
  managerId?: number | null;
}

export const listSimulationClients = () =>
  unwrap<SimulationClientSummary[]>(
    api({
      method: "GET",
      url: "/admin/trades/clients",
    })
  );
